// Service to read projects from markdown files
import { projectsData } from './parsedProjects';

// Service functions to match the Firebase API
export const getProjects = () => {
  return Promise.resolve(projectsData);
};

export const getProjectById = (id) => {
  const project = projectsData.find(p => p.id === id || p.slug === id);
  return Promise.resolve(project);
};

export const getProjectsByCategory = (category) => {
  if (category === 'all') {
    return Promise.resolve(projectsData);
  }
  
  const filtered = projectsData.filter(project => 
    project.category === category && project.published
  );
  return Promise.resolve(filtered);
};

export const getFeaturedProjects = async (limitCount = 3) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const featured = projectsData
        .filter(p => p.published)
        .sort((a, b) => b.date - a.date)
        .slice(0, limitCount);
      resolve(featured);
    }, 100);
  });
};

const projectService = {
  getProjects,
  getProjectById,
  getProjectsByCategory,
  getFeaturedProjects
};

export default projectService; 